module.exports = __webpack_public_path__ + "static/media/work-be-curious.6ce3b353.jpg";